module.exports = __webpack_public_path__ + "static/practice1-8b6d1de8a9acf7a9f73f788a322582a0.png";